<template>
    <div v-if="deal" :class="colorClass" class="deal-card">
        <v-row>
            <v-col>
                <h3>{{ deal.name }}</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-if="deal.dealType == dateTypes.AMOUNT">
                ${{ deal.dealValue.toFixed(2) }} {{ deal.dealItem }}
            </v-col>
            <v-col v-if="deal.dealType == dateTypes.BUYONEGET">
                Buy 1 {{ deal.dealItem }} Get {{ deal.dealValue }} Free
            </v-col>
        </v-row>
    </div>
</template>

<script>
import DateTypeEnum from '../../../assets/Enums/DealTypeEnum'
import moment from 'moment'

export default {
    name: 'deal-card',
    props: {
        deal: {
            type: Object,
            defualt: () => {},
        }
    },
    computed: {
        colorClass() {
            return this.morningDeal ? 'morning' :
                this.noonDeal ? 'noon' : 'evening';
        },
        morningDeal() {
            return moment(this.deal.start).hour() <= 11
        },
        noonDeal() {
            return moment(this.deal.start).hour() > 11 && moment(this.deal.start).hour() <= 17
        },
        eveningDeal() {
            return moment(this.deal.start).hour() > 17 && moment(this.deal.start).hour() <= 23
        },
        dateTypes() {
            return DateTypeEnum;
        }
    },
}
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.deal-card {
    width: 150px;
    min-height: 150px;
    padding: 0.5em;
    border-radius: 5px;
}

.deal-card.morning {
    background-color: rgba(255, 176, 107, 0.15);
    outline: rgb(255, 176, 107) solid 3px;
}

.deal-card.noon {
    background-color: rgba(238, 29, 0, 0.15);
    outline: rgb(238, 29, 0) solid 3px;
}

.deal-card.evening {
    background-color: rgba(0, 0, 109, 0.15);
    outline: rgb(0, 0, 109) solid 3px;
}
</style>